import BenchlingConfig from 'BenchlingConfig';

export const DEFAULT_MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024;

export function getMaxFileSizeBytes(): number {
  const maxMB = BenchlingConfig.ELN_MAX_FILE_UPLOAD_SIZE_MB;
  return maxMB != null ? maxMB * 1024 * 1024 : DEFAULT_MAX_FILE_SIZE_BYTES;
}

export function isFileSizeTooLarge(fileSizeBytes: number): boolean {
  return fileSizeBytes > getMaxFileSizeBytes();
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) {
    return '0 Bytes';
  }
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export function validateFileForUpload(file: File): string | null {
  if (isFileSizeTooLarge(file.size)) {
    const maxSize = formatFileSize(getMaxFileSizeBytes());
    const actualSize = formatFileSize(file.size);
    return `File size (${actualSize}) exceeds the maximum allowed size of ${maxSize}`;
  }

  return null;
}
